module.exports = __webpack_public_path__ + "static/media/Leslie_Switzer.fcba4719.png";